module.exports = __webpack_public_path__ + "static/pr-op-packing@2x-a2efd1329a047fabcbf0afaa7c7840d9.png";